import * as _ from "lodash";
import PropTypes from "prop-types";
import React, { useState } from "react";
import {
    Tab as ReactTabTitle,
    TabList,
    TabPanel,
    Tabs as ReactTabs,
} from "react-tabs";

/**
 * Tab container that renders tab titles and corresponding tab panels from children.
 *
 * @param root0 - The component props.
 * @param root0.children - The tab panel elements to render.
 * @returns The rendered tabs component.
 */
const Tabs = ({ children = [], ...restProps }) => {
    const [activeTabKey, setActiveTabKey] = useState(0);

    const onChangeTab = (tabKey) => {
        setActiveTabKey(tabKey);
    };

    const renderTabTitle = (child) => {
        return (
            <ReactTabTitle key={_.kebabCase(`${child.props.title}-tab-title`)}>
                {child.props.title}
            </ReactTabTitle>
        );
    };

    const renderTabContent = (child) => {
        return (
            <div
                key={_.kebabCase(`${child.props.title}-tab`)}
                className="tab-form"
            >
                <TabPanel>{child}</TabPanel>
            </div>
        );
    };

    const tabsTitles = [];
    const tabsContents = [];
    _.forEach(children, (child) => {
        tabsTitles.push(renderTabTitle(child));
        tabsContents.push(renderTabContent(child));
    });

    return (
        <ReactTabs
            {...restProps}
            forceRenderTabPanel
            defaultIndex={activeTabKey}
            onSelect={onChangeTab}
        >
            <TabList>{tabsTitles}</TabList>
            <span className="tabs-content">{tabsContents}</span>
        </ReactTabs>
    );
};

Tabs.createTab = (title, component, props) =>
    React.createElement(component, { title, key: title, ...props });

Tabs.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Tabs;
